import { RouterProvider } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createAppTheme, ToastProvider } from '@foxtaibox/foxtailbox-frontend-core';
import { DialogProvider } from 'context/dialogContext';
import { ResultModalProvider } from 'context/resultModalContext';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import router from './router';
import './assets/style.css';
import 'highlight.js/styles/github.css'; // должен быть единый здесь и на платформе

dayjs.extend(duration);

const theme = createAppTheme();

const App = () => (
  <ThemeProvider theme={theme}>
    <ToastProvider>
      <DialogProvider>
        <ResultModalProvider>
          <CssBaseline />
          <RouterProvider router={router} />
        </ResultModalProvider>
      </DialogProvider>
    </ToastProvider>
  </ThemeProvider>
);

export default App;
